const Initreducer = (state, { type, payload }) => {
    switch (type) {
        case 'setsystem_option':
            return { ...state, system_option: payload.system_option, certificate: payload.certificate };
        default:
            return state;
    }
}

export default Initreducer;